import { render, staticRenderFns } from "./ques-indefinite.vue?vue&type=template&id=15cf584a&scoped=true"
import script from "./ques-indefinite.vue?vue&type=script&lang=js"
export * from "./ques-indefinite.vue?vue&type=script&lang=js"
import style0 from "./ques-indefinite.vue?vue&type=style&index=0&id=15cf584a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf584a",
  null
  
)

export default component.exports